// NO TYPES, NO INTERFACES (JS ONLY)
import Icon from 'components/AppIcon';
import { X } from 'lucide-react';

export default function CalculationNote(props) {
  const { open = false, onClose } = props;

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex w-full h-full items-start justify-center pt-10">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />

      {/* CRITICAL: Stop propagation so clicking INSIDE doesn't close modal */}
      <div
        className="relative z-10 w-[800px] max-w-2xl rounded-lg bg-white p-5 shadow-lg"
        onClick={(e) => e.stopPropagation()} // THIS WAS MISSING IN TS VERSION!
      >
        <div className="mb-3 flex items-start justify-between">
          <div className="flex items-center gap-2">
            <Icon name={'TriangleAlert'} className="h-5 w-5 text-yellow-600" />
            <h2 className="text-base font-semibold text-slate-800">How Calculation works</h2>
          </div>
          <button
            onClick={onClose}
            className="rounded-md p-1 text-slate-400 hover:bg-slate-100 hover:text-slate-600"
          >
            <X className="h-4 w-4" />
          </button>
        </div>

        <div className="space-y-2 text-sm text-slate-700">
          <p>Salary is calculated with decimals but shown rounded (difference ± ₹1 – ₹3 max).</p>
          <p>
            Time is shown in <span className="font-semibold">minutes only</span> (no seconds).
          </p>
          <p>Examples:</p>
          <ul className="ml-5 list-disc space-y-1">
            <li>
              <code>3.40 min → shown as 3 min</code>
            </li>
            <li>
              <code>3.50 + 3.50 + 3.50 = 11.50 → shown as 11 min</code>
            </li>
          </ul>
        </div>

        <div className="mt-4 flex justify-end">
          <button
            onClick={onClose}
            className="rounded-md bg-blue-600 px-4 py-1.5 text-sm font-medium text-white hover:bg-blue-700"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
}
